interface EventsSectionProps {
  isDarkMode?: boolean;
}

export default function EventsSection({ isDarkMode = false }: EventsSectionProps) {
  const events = [
    {
      title: '2026 三月十四日乒乓及卡啦OK大賽',
      date: '2026年3月',
      location: '中式酒樓',
      category: '錦標賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/0fa3df6c8d48089196982f39eb26b950.jpeg',
      status: '報名中'
    },
    {
      title: '聯會乒乓球友誼賽',
      date: '2026年2月1日',
      location: '粉嶺區體育館',
      category: '培訓',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/116dab0cefa05cbdde911bb1c2ab9aa3.png',
      status: '即將開始'
    },
    {
      title: '聯會友誼交流比賽',
      date: '2026年6月',
      location: '粉嶺或大埔',
      category: '聯賽',
      image: 'https://static.readdy.ai/image/ceffbd0e215ee7f6434042c96230b75d/395a8399b663b5668367e7bb41e6f549.jpeg',
      status: '籌備中'
    },
    {
      title: '國際友誼賽',
      date: '2026 下半年',
      location: '澳門綜合體育館',
      category: '友誼賽',
      image: 'https://public.readdy.ai/ai/img_res/6dae14b2681afdbc2a5c1d38be4b7b97.jpg',
      status: '籌備中'
    }
  ];

  return (
    <section id="events" className={`py-24 ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`text-5xl md:text-6xl font-black mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            賽事活動
          </h2>
          <div className="w-24 h-1.5 bg-emerald-600 mx-auto mb-6"></div>
          <p className={`text-xl max-w-3xl mx-auto ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            精彩賽事，等你參與
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {events.map((event, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4">
                  <span className="px-4 py-2 bg-emerald-600 text-white text-sm font-bold rounded-full shadow-lg">
                    {event.status}
                  </span>
                </div>
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 bg-white/95 text-gray-900 text-sm font-bold rounded-full shadow-lg">
                    {event.category}
                  </span>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {event.title}
                </h3>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-gray-600">
                    <div className="w-6 h-6 flex items-center justify-center mr-3">
                      <i className="ri-calendar-line text-lg text-emerald-600"></i>
                    </div>
                    <span>{event.date}</span>
                  </div>
                  <div className="flex items-center text-gray-600">
                    <div className="w-6 h-6 flex items-center justify-center mr-3">
                      <i className="ri-map-pin-line text-lg text-emerald-600"></i>
                    </div>
                    <span>{event.location}</span>
                  </div>
                </div>

                <button className="w-full px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                  <i className="ri-file-list-line mr-2"></i>
                  查看詳情
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/events"
            className="inline-block px-10 py-4 bg-gray-900 hover:bg-gray-800 text-white text-lg font-bold rounded-full transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            查看所有賽事
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
